import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { focusRing } from '../styles/ui';

const CartBadge = () => {
  const { itemCount } = useCart();

  return (
    <Link
      to="/cart"
      aria-label={`View cart${itemCount > 0 ? `, ${itemCount} item${itemCount === 1 ? '' : 's'}` : ''}`}
      className={`relative inline-flex items-center justify-center w-11 h-11 rounded-xl text-emerald-900 hover:bg-emerald-50 transition-colors ${focusRing}`}
    >
      <ShoppingCart size={22} aria-hidden="true" />
      {itemCount > 0 && (
        <span className="absolute top-1 right-1 min-w-[1.1rem] h-[1.1rem] px-1 rounded-full bg-accent-500 text-white text-[10px] font-bold flex items-center justify-center shadow-soft">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </Link>
  );
};

export default CartBadge;
